import Controller from '@ember/controller';

import { get, set, action, computed } from '@ember/object';
import { reads } from '@ember/object/computed';

import { task, timeout } from 'ember-concurrency';

import { paesiMondoAlfa3, paesiMondoAlfa2 } from 'beebee-base/lib/list_taxes';

import { inject as iController } from '@ember/controller';

import { inject as iService } from '@ember/service';
import getConfig from 'beebee-base/lib/get-config';
import {
  beebeeAjaxGet,
  beebeeAjaxPost,
  clearAttribute,
  notifyUserError,
} from 'beebee-base/lib/utility';

export default class CheckinController extends Controller {
  @iService notify;
  @iController('application') applicationController;
  @iService intl;
  @iService store;
  @iService session;
  @iService log;

  saferegister = false;

  notFound = false;

  @reads('session.option_field.ecommerce_general_term') generalTerms;

  @computed(
    'generalTerms',
    'termAccepted',
    'applicationController.gdprField.organization_term_options.data.@each.{required,registration,active}'
  )
  get canBuy() {
    const { generalTerms, termAccepted } = this;

    if (generalTerms) {
      if (termAccepted) {
        let requiredActive = true;

        const organizationTermOptions =
          this.applicationController?.gdprField?.organization_term_options?.data;

        if (Array.isArray(organizationTermOptions)) {
          organizationTermOptions.forEach(function (d) {
            if (d.required && d.registration && !d.active) {
              requiredActive = false;
            }
          });
        }

        return requiredActive;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  checkRequired(showError = true) {
    //const contact = this.store.peekRecord('contact', this.session.me?.id);
    const contact = this.me;
    const fieldReset = [
      'nameError',
      'ragSocialeError',
      'birthError',
      'luogoError',
      'mobileError',
      'mailError',
      'cfError',
      'codfiscaleError',
      'addressError',
    ];
    const fieldTrim = [
      'ragione_sociale',
      'first_name',
      'last_name',
      'cod_fiscale',
      'luogo_nascita',
      'mail',
      'mobile',
    ];

    // Reset error fields if showError is true
    if (showError) {
      fieldReset.forEach((field) => {
        set(contact, field, false);
      });
    }

    // Trim fields
    fieldTrim.forEach((field) => {
      const value = clearAttribute(contact.get(field));
      set(contact, field, value);
    });

    let checkField = true;
    const notRequired = this.not_required_field || {};
    const isFisicaGiuridica = contact.get('fisica_giuridica');
    const address = contact.get('addresses')[0];
    const country = address?.location_address_country;
    const countryCode = address?.location_address_country_code;

    // Check for 'ragione sociale' or name fields
    if (isFisicaGiuridica) {
      if (!contact.get('ragione_sociale')) {
        if (showError) {
          set(contact, 'ragSocialeError', true);
        }
        checkField = false;
      }
    } else {
      if (!contact.get('first_name') || !contact.get('last_name')) {
        if (showError) {
          set(contact, 'nameError', true);
        }
        checkField = false;
      }
    }

    // Check birth and place of birth fields
    if (!contact.get('data_nascita') && !notRequired.data_nascita) {
      if (showError) {
        set(contact, 'birthError', true);
      }
      checkField = false;
    }
    if (!contact.get('luogo_nascita') && !notRequired.luogo_nascita) {
      if (showError) {
        set(contact, 'luogoError', true);
      }
      checkField = false;
    }

    // Check email and mobile
    if (!contact.get('mail')) {
      if (showError) {
        set(contact, 'mailError', true);
      }
      checkField = false;
    }
    if (!contact.get('mobile') && !notRequired.mobile) {
      if (showError) {
        set(contact, 'mobileError', true);
      }
      checkField = false;
    }

    if (this.setUsername && !this.tmpUsername) {
      if (showError) {
        set(contact, 'usernameError', true);
      }
      checkField = false;
    }

    if (this.setUsername && !this.tmpUPassword) {
      if (showError) {
        set(contact, 'passwordError', true);
      }
      checkField = false;
    }

    // Check address fields
    if (
      !(
        address?.location_address_street &&
        address?.location_address_house &&
        address?.location_address_postal_code &&
        address?.location_address_city &&
        address?.location_address_country
      ) &&
      !notRequired.address
    ) {
      if (showError) {
        set(contact, 'addressError', true);
      }
      checkField = false;
    }

    // Check Codice Fiscale for Italian addresses
    const isItaly = country === 'Italia' || ['IT', 'ITA'].includes(countryCode);
    if (isItaly) {
      // completaStraniero() must never run for Italian contacts: it would
      // overwrite the real postal code / fiscal data with placeholder values.
      if (
        !notRequired.cod_fiscale &&
        (!contact.get('cod_fiscale') || contact.get('codFiscaleValidMsg'))
      ) {
        if (showError) {
          set(contact, 'cfError', true);
        }
        checkField = false;
      }
    } else {
      this.completaStraniero();
    }

    return checkField;
  }

  completaStraniero() {
    const item = this.me;
    const contactAddress = item.addresses[0];
    const countryCode = contactAddress?.location_address_country_code;
    const contactId = item.id || '';

    if (!countryCode) {
      this.notify.warning('Seleziona prima un indirizzo!');
      return;
    }

    const convertCountryCodeToAlpha2 = (countryCode) => {
      const index = paesiMondoAlfa3.indexOf(countryCode);

      if (index === -1) {
        return countryCode.substring(0, 2);
      }

      return paesiMondoAlfa2[index];
    };

    const alpha2Code = convertCountryCodeToAlpha2(countryCode);

    set(contactAddress, 'location_address_postal_code', '00000');
    set(item, 'codice_destinatario', 'XXXXXXX');

    if (item.fisica_giuridica) {
      const rimanentiCF = 14 - contactId.length;
      const contactCF = `${alpha2Code}${'00000000000000'.substring(0, rimanentiCF)}${contactId}`;
      set(item, 'cod_fiscale', contactCF);
    } else {
      set(item, 'cod_fiscale', null);
    }

    const rimanentiPIVA = 11 - contactId.length;
    const pIVA = `${alpha2Code}${'999999999'.substring(0, rimanentiPIVA)}${contactId}`;
    set(item, 'piva', pIVA);
  }

  @(task(function* () {
    try {
      if (this.session.token) {
        const me = yield beebeeAjaxGet(
          `${getConfig(this).APP.urlApi}/contacts/me`,
          this.session.token
        );

        // A failed/empty /contacts/me resolves to undefined; me.data.id then
        // threw (twin of Sentry EMBER-SCUOLE-ECOMMERCE-2XM). Guard the payload.
        const meId = me?.data?.id;
        if (!meId) {
          return;
        }

        this.store.pushPayload(me);
        const itemStore = this.store.peekRecord('contact', `${meId}`);

        if (!itemStore) {
          return;
        }

        if (!itemStore.addresses.length) {
          itemStore.addresses.push(
            get(this, 'store').createRecord('address', {
              is_invoice: true,
              location_address_country: 'Italia',
              location_address_country_code: 'IT',
            })
          );
        }

        set(this, 'me', itemStore);
      } else if (!this.saferegister) {
        this.createNewMe();
      }
    } catch (e) {
      // Left uncaught, a 4xx/network failure here surfaced as a Sentry
      // unhandled rejection. Background loader: log only, no notify.
      this.log.warn('checkin loadDataTask: /contacts/me failed', e);
    }
  }).drop())
  loadDataTask;

  createNewMe() {
    const me = this.store.createRecord('contact');

    me.addresses.push(
      get(this, 'store').createRecord('address', {
        is_invoice: true,
        location_address_country: 'Italia',
        location_address_country_code: 'IT',
      })
    );

    set(this, 'me', me);
  }

  createDataObj() {
    const hashString = (str) => {
      let hash = 0;
      for (let i = 0; i < str.length; i++) {
        hash = (hash << 5) - hash + str.charCodeAt(i);
        hash |= 0; // Forza a 32-bit
      }
      return Math.abs(hash).toString(16); // Converte il valore in esadecimale
    };

    // Preleva e pulisce i campi principali
    const ragione_sociale = clearAttribute(this.me.get('ragione_sociale')) ?? '';
    const first_name = clearAttribute(this.me.get('first_name')) ?? '';
    const last_name = clearAttribute(this.me.get('last_name')) ?? '';
    const mail = clearAttribute(this.me.get('mail')) ?? '';

    const contact = {
      id: this.me.get('id'),
      gdpr: this.applicationController.get('gdprField.organization_term_options.data'),
      fisica_giuridica: this.me.get('fisica_giuridica'),
      ragione_sociale,
      first_name,
      last_name,
      data_nascita: clearAttribute(this.me.get('data_nascita')),
      luogo_nascita: clearAttribute(this.me.get('luogo_nascita')),
      piva: clearAttribute(this.me.get('piva')),
      cod_fiscale: clearAttribute(this.me.get('cod_fiscale')),
      mail,
      mobile: clearAttribute(this.me.get('mobile')),
      addresses: [],
    };

    // Aggiungi un indirizzo se disponibile
    if (this.me.get('addresses')[0]?.name) {
      contact.addresses.push(this.createAddressObj());
    }

    // Crea l'oggetto dati con la validazione
    const data = {
      contact,
      custom_fields: [],
      validation: hashString(`${mail}|${first_name}|${last_name}|${ragione_sociale}`),
    };

    return data;
  }

  createAddressObj() {
    const firstAddress = this.me?.get('addresses')[0];

    if (!firstAddress) {
      return null;
    }

    const clearAttribute = (value) => {
      if (typeof value === 'string') {
        return value.replace(/'/g, ' ');
      }
      return value;
    };

    const a = {
      id: firstAddress.id,
      attributes: {
        id: firstAddress.id,
        name: clearAttribute(firstAddress.name),
        icon: firstAddress.icon,
        view: firstAddress.view,
        place_id: firstAddress.place_id,
        location_position_lat: clearAttribute(firstAddress.location_position_lat),
        location_position_lng: clearAttribute(firstAddress.location_position_lng),
        location_address_text: clearAttribute(firstAddress.location_address_text),
        location_address_house: clearAttribute(firstAddress.location_address_house),
        location_address_street: clearAttribute(firstAddress.location_address_street),
        location_address_postal_code: clearAttribute(firstAddress.location_address_postal_code),
        location_address_city: clearAttribute(firstAddress.location_address_city),
        location_address_county: clearAttribute(firstAddress.location_address_county),
        location_address_state: clearAttribute(firstAddress.location_address_state),
        location_address_country: clearAttribute(firstAddress.location_address_country),
        location_address_country_code: clearAttribute(firstAddress.location_address_country_code),
        categories_id: firstAddress.categories_id,
        categories_title: clearAttribute(firstAddress.categories_title),
        type: firstAddress.type,
        is_invoice: firstAddress.is_invoice,
        accuracy: firstAddress.accuracy,
        heading: firstAddress.heading,
      },
    };

    for (const name in a) {
      a[name] = clearAttribute(a[name]);
    }

    return a;
  }

  @(task(function* () {
    yield timeout(250);

    const checkField = this.checkRequired();
    if (checkField) {
      const dataSave = this.createDataObj();
      dataSave.contact.username = this.tmpUsername;
      dataSave.contact.password = this.tmpUPassword;

      try {
        const saveAPIMe = yield beebeeAjaxPost(
          `${getConfig(this).APP.urlApi}/checkin/savecontact`,
          this.session.token,
          dataSave
        );

        const redirectUrl = this.session.option_field?.redirect_checkin;
        if (redirectUrl) {
          window.location.replace(redirectUrl);
          return;
        }

        set(this, 'saveAPIMe', saveAPIMe);
        return saveAPIMe;
      } catch (e) {
        notifyUserError(this.notify, e, this.intl);
      }
    } else {
      this.notify.warning(this.intl.t('missing mandatory fields'));
    }
  }).drop())
  saveMeTask;

  @(task(function* () {
    try {
      yield beebeeAjaxPost(
        `${getConfig(this).APP.urlApi}/user_registration_request`,
        this.session.token,
        {
          data: {
            attributes: {
              mail: this.me.get('mail'),
              contact_id: this.me.get('id'),
            },
          },
        }
      );

      this.notify.success(`${this.intl.t('message sent to')} ${this.me.get('mail')}`);
    } catch (e) {
      this.notify.error(this.intl.t('beebeeboard error'));
    }
  }).drop())
  sendInvitation;

  @(task(function* () {
    yield timeout(250);

    set(this, 'checkAPIMail', null);
    try {
      const checkAPIMail = yield beebeeAjaxGet(
        `${getConfig(this).APP.urlApi}/checkin/checkmail`,
        null,
        {
          mail: this.checkMail,
          organization_name: this.session?.openOrganization?.name,
          thumbnail_url: this.session?.openOrganization?.thumbnail_url,
          color: this.session?.openOrganization?.primary_color,
          lang: this.intl.primaryLocale,
        }
      );

      set(this, 'checkAPIMail', checkAPIMail);
    } catch (e) {
      this.log.error('checkin: checkAPIMail load failed', e);
    }
  }).drop())
  findMailTask;

  // `{{on 'submit'}}` does not prevent the native form submission the way the
  // old `{{action ... on='submit'}}` did; without this the browser reloads the
  // page on submit.
  @action
  findMailSubmit(event) {
    event?.preventDefault?.();
    return this.findMailTask.perform();
  }

  @action
  resetForm() {
    set(this, 'me', null);
    set(this, 'checkAPIMail', null);
    set(this, 'saveAPIMe', null);
    set(this, 'access_token', null);
  }

  @action
  newRegistration() {
    this.createNewMe();
    set(this, 'checkAPIMail', null);
    set(this, 'saveAPIMe', null);
    set(this, 'access_token', null);
  }
}
